<template>
  <div class="h5-polish-redirect" role="status" aria-live="polite">
    <i class="el-icon-loading"></i>
    <span>正在打开润色改写…</span>
  </div>
</template>

<script>
export default {
  name: "TransPolish",
  created() {
    const navigation = this.$router.replace({
      path: '/translate',
      query: { type: 'polish' }
    })
    if (navigation && typeof navigation.catch === 'function') {
      navigation.catch(() => {})
    }
  }
}
</script>


<style lang="less" scoped>
.h5-polish-redirect {
  min-height: 100vh;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-sizing: border-box;
  color: #5f7185;
  background: #f5f8fb;
  font-size: 15px;
}

.h5-polish-redirect i {
  color: #0c7dba;
  font-size: 28px;
}
</style>
